<div [@animateStagger]="{ value: '50' }">
  @switch (theme) {
    @case (themes.CLASSIC) {
      <div
        class="buttons-classic"
        fxLayout.xs="column"
        [fxLayoutAlign]="layout === 'row' ? 'space-around center' : 'stretch'"
        [fxLayout]="layout"
      >
        @for (provider of classicButtonProviders; track provider.provider) {
          @if (provider.provider | map: hasProvider : this) {
            <button
              mat-button
              [@animate]="{
                value: '*',
                params: { duration: '300ms', y: '100px' }
              }"
              [ngClass.xs]="{ 'space-full-xs': true }"
              (click)="processLegalSignUP(provider.provider)"
            >
              <mat-icon [svgIcon]="provider.svgIcon" />
              {{ provider.label }}
            </button>
          }
        }
      </div>
    }

    @case (themes.STROKED) {
      <div
        class="buttons-classic"
        fxLayout.xs="column"
        [fxLayoutAlign]="layout === 'row' ? 'space-around center' : 'stretch'"
        [fxLayout]="layout"
      >
        @for (provider of classicButtonProviders; track provider.provider) {
          @if (provider.provider | map: hasProvider : this) {
            <button
              mat-stroked-button
              [@animate]="{
                value: '*',
                params: { duration: '300ms', y: '100px' }
              }"
              [ngClass.xs]="{ 'space-full-xs': true }"
              (click)="processLegalSignUP(provider.provider)"
            >
              <mat-icon [svgIcon]="provider.svgIcon" />
              {{ provider.label }}
            </button>
          }
        }
      </div>
    }

    @case (themes.RAISED) {
      <div
        class="buttons-raised"
        fxLayout.xs="column"
        [fxLayoutAlign]="layout === 'row' ? 'space-around center' : 'stretch'"
        [fxLayout]="layout"
      >
        @for (provider of classicButtonProviders; track provider.provider) {
          @if (provider.provider | map: hasProvider : this) {
            <button
              mat-raised-button
              [@animate]="{
                value: '*',
                params: { duration: '300ms', y: '100px' }
              }"
              [ngClass.xs]="{ 'space-full-xs': true }"
              (click)="processLegalSignUP(provider.provider)"
            >
              <mat-icon [svgIcon]="provider.svgIcon" />
              {{ provider.label }}
            </button>
          }
        }
      </div>
    }

    @case (themes.FAB) {
      <div
        class="buttons-raised"
        [fxLayoutAlign]="layout === 'row' ? 'space-around center' : 'stretch'"
        [fxLayout]="layout"
      >
        @for (provider of miniFabProviders; track provider.provider) {
          @if (provider.provider | map: hasProvider : this) {
            <button
              mat-fab
              [class]="provider.class"
              [@animate]="{
                value: '*',
                params: { duration: '300ms', y: '100px' }
              }"
              (click)="processLegalSignUP(provider.provider)"
            >
              <mat-icon [svgIcon]="provider.svgIcon" />
            </button>
          }
        }
      </div>
    }

    @case (themes.MINI_FAB) {
      <div
        class="buttons-raised"
        fxLayoutAlign.xs="center center"
        [fxLayoutAlign]="layout === 'row' ? 'space-around center' : 'stretch'"
        [fxLayout]="layout"
      >
        @for (provider of miniFabProviders; track provider.provider) {
          @if (provider.provider | map: hasProvider : this) {
            <button
              fxFlexAlign="center"
              mat-mini-fab
              [class]="provider.class"
              [@animate]="{
                value: '*',
                params: { duration: '300ms', y: '100px' }
              }"
              (click)="processLegalSignUP(provider.provider)"
            >
              <mat-icon
                [ngClass]="provider.svgClass"
                [svgIcon]="provider.svgIcon"
              />
            </button>
          }
        }
      </div>
    }

    @default {
      <div
        fxLayout.xs="column"
        [fxLayoutAlign]="layout === 'row' ? 'space-around center' : 'stretch'"
        [fxLayout]="layout"
      >
        @for (provider of iconButtonProviders; track provider.provider) {
          @if (provider.provider | map: hasProvider : this) {
            <button
              mat-button
              [@animate]="{
                value: '*',
                params: { duration: '300ms', y: '100px' }
              }"
              [ngClass.xs]="{ 'space-full-xs': true }"
              (click)="processLegalSignUP(provider.provider)"
            >
              <mat-icon [svgIcon]="provider.svgIcon" />
              {{ provider.label }}
            </button>
          }
        }
      </div>
    }
  }
</div>
